"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTripletsView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ui_1 = require("@obvio/ui");
const GridLayoutOfThreeView_1 = require("./GridLayoutOfThreeView");
const GridTripletsView_1 = require("./GridTripletsView");
const productTile_1 = require("../../productTile");
const getPosition = (odd, startFromRight) => {
    const newPosition = (odd ? -1 : 1) * (startFromRight ? -1 : 1);
    return newPosition === 1 ? 'right' : 'left';
};
function ProductTripletsView({ products, className, startFromRight, tileRenderer = productTile_1.ProductTileView, }) {
    const render = (product) => tileRenderer({ product, className: 'animated fadeIn', key: product.id });
    return ((0, jsx_runtime_1.jsx)(GridTripletsView_1.GridTripletsView, { className: className, elements: products, renderThree: (data, odd) => ((0, jsx_runtime_1.jsx)(GridLayoutOfThreeView_1.GridLayoutOfThreeView, { data: data, layout: getPosition(odd, startFromRight), render: render }, data[0].id)), renderTwo: (data) => ((0, jsx_runtime_1.jsx)(ui_1.Grid, Object.assign({ templateColumns: "repeat(2,minmax(0,1fr))" }, { children: data.map(render) }), data[0].id)), renderOne: (data) => (0, jsx_runtime_1.jsx)(productTile_1.ProductTileView, { product: data }) }));
}
exports.ProductTripletsView = ProductTripletsView;
